import { Button, DropZone, InlineStack, Text, Thumbnail, BlockStack, Icon } from '@shopify/polaris';
import React, { ReactElement, useState } from 'react';
import { DI, DIProps } from '../../../../../Core';
import useContextLayer from '../../Context/helper';
import { NoteMinor, MobileCancelMajor, CancelSmallMinor } from '@shopify/polaris-icons';
import { ACTION_TYPE } from '../../Context/actiontypes';
import { shouldAddImages } from './imagehelper';
import { useTranslation } from 'react-i18next';
interface Props extends DIProps {
    exceededFiles: string[];
}

function CustomDropZone(props: Props): ReactElement {
    const { t } = useTranslation();
    const { state, dispatch } = useContextLayer();
    const [files, setFiles] = useState<any>([]);
    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

    // Function to remove EXIF data using a canvas
    const removeExifFromImage = (file: File) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    // Create a canvas to draw the image and strip the EXIF data
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = img.width;
                    canvas.height = img.height;

                    // Draw the image on the canvas
                    ctx?.drawImage(img, 0, 0);

                    // Convert the canvas content to a Blob (image) without EXIF
                    canvas.toBlob((blob) => {
                        const uniqueName = generateUniqueFileName(file);
                        const renamedFile = new File([blob!], uniqueName, { type: file.type });

                        resolve(renamedFile);
                        // resolve(blob);
                    }, file.type);
                };
                img.onerror = reject;
                img.src = e.target?.result as string;
            };
            reader.onerror = reject;
            reader.readAsDataURL(file); // Read the file as Data URL
        });
    };

    // Function to generate a unique file name
    const generateUniqueFileName = (file: File) => {
        const timestamp = Date.now(); // Or use `uuidv4()` for a UUID-based name
        const fileExtension = file.name.split('.').pop(); // Get the file extension
        const newName = `${file.name.split('.')[0]}_${timestamp}.${fileExtension}`;
        return newName;
    };

    function handleDropZoneDrop(event: any) {
        console.log(event, state?.shopify_images, "vfjdv", state);

        if (event?.length > 5)
            props.error('You cannot upload more than 5 images at once');
        else if (event?.length + state?.shopify_images?.length > 20) props.error("You can't upload size greater than 20")
        else {
            if (shouldAddImages(event)) {
                let tempImgArray: any = [...event];
                tempImgArray = tempImgArray.filter((file: { type: string }) => validImageTypes.includes(file.type));
                if (tempImgArray.length < [...event].length) {
                    props.error(`${[...event].length - tempImgArray.length} file(s) of unsupported type removed`);
                }
                 // Remove EXIF data from each image before uploading
                 // Remove EXIF data and prepare the image
                 const filesWithNoExif = Promise.all(tempImgArray.map(removeExifFromImage)).then( e => {
                    Promise.all(e).then((strippedFiles) => {
                        dispatch({
                            type: ACTION_TYPE.UPLOAD_IMAGE_ARRAY,
                            payload: {
                                [ACTION_TYPE.UPLOAD_IMAGE_ARRAY]: strippedFiles,
                            },
                        });
                    }).catch(err => props.error('Error removing EXIF data'));
                 });

                
                // dispatch({
                //     type: ACTION_TYPE.UPLOAD_IMAGE_ARRAY,
                //     payload: {
                //         [ACTION_TYPE.UPLOAD_IMAGE_ARRAY]: tempImgArray,
                //     },
                // });
            }
            else props.error('Incorrect format')
        }
    }

    console.log(props.exceededFiles, "dfvknfv");


    const fileUpload = !state?.['upload_image_array']?.length && (
        <DropZone.FileUpload actionTitle={t('Add File')} />
    );
    const uploadedFiles = state?.['upload_image_array']?.length > 0 && (
        <div style={{ padding: '20px' }}>
            <InlineStack gap={"500"} wrap>
                {state?.['upload_image_array'].map((file: any, index: any) => (
                    <div key={index + 'outerMost'} className={props.exceededFiles.includes(file.name) ? "custom-error-description" : undefined}>
                        <BlockStack gap={"200"} inlineAlign='start'>
                            <div className='custom-add-image-upload'>
                                <Thumbnail
                                    size="large"
                                    alt={file.name}
                                    source={
                                        validImageTypes.includes(file.type)
                                            ? window.URL.createObjectURL(file)
                                            : NoteMinor
                                    }
                                />
                                 <span className='custom-selected-images__amz--icon'  
                                 onClick={(event?: any) => { removeImage(event, index) }}>
                                    <Icon source={CancelSmallMinor} tone='primary' />
                                </span>
                            </div>
                            <BlockStack gap={"050"}>
                                <Text variant='bodySm' as='p'>{file.name}</Text>
                                <Text variant="bodySm" as="p" tone='subdued'>{file.size} bytes</Text>
                            </BlockStack>
                        </BlockStack>
                    </div>
                ))}
            </InlineStack>
        </div>
    );

    function removeImage(e?: any, index?: any) {
        e.stopPropagation();
        let temp: any = [...(state?.['upload_image_array'] ?? [])];
        temp = temp.filter((image: any, ind: any) => ind != index);
        dispatch({
            type: ACTION_TYPE.UPLOAD_IMAGE_ARRAY,
            payload: {
                [ACTION_TYPE.UPLOAD_IMAGE_ARRAY]: temp,
            },
        });
    }

    return (
        <DropZone onDrop={handleDropZoneDrop}>
            {uploadedFiles}
            {fileUpload}
        </DropZone>
    );
}

export default DI(CustomDropZone);